import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

import Group from 'components/utils/Group'

const StyledGroup = styled(Group)`
  /*
    This CSS ensures the filter chip's parent accounts for their focus/active outline styles
    so that the scrollable container doesn't vertically scroll when the user interacts with the chips
  */
  padding: ${rem(4)} ${rem(8)};
  margin: 0 ${rem(-4)};

  @media print {
    display: none;
  }
`

function FilterChipsWrapContainer({ children }: PropsWithChildren<{ }>) {
  return (
    <StyledGroup gap={8} horizontalAlign="start" direction="horizontal" wrap="wrap">
      {children}
    </StyledGroup>
  )
}

export default FilterChipsWrapContainer
